import React from "react";
import {
    Avatar,
    makeStyles,
    Card,
    Paper,
} from "@material-ui/core";


const useStyles = makeStyles(() => ({
    avatar: {
        width: "130px",
        height: "130px",
        marginTop: "40%",
        marginLeft: "20px",
        marginRight: "20px",
    },
    centerHorizontal: {
        marginLeft: "auto",
        marginRight: "auto",
    },
    flex1: {
        flexGrow: 1,
    },
    paperPlaceHolder: {
        height: "30px",
        marginTop: "6px",
        marginBottom: "6px",
        backgroundColor: "#bdbdbd",
    },
    size1: {
        width: "50%",
        maxWidth: "200px",
    },
    size2: {
        width: "40%",
        maxWidth: "100px",
    },
}));


export default function UndefinedOpponent(): JSX.Element {
    const classes = useStyles();

    return (
        <Card elevation={0} className={`${classes.flex1}`}>
            <Avatar className={`${classes.centerHorizontal}  ${classes.avatar}`}>
                ?
            </Avatar>
            <Paper className={`${classes.paperPlaceHolder} ${classes.centerHorizontal} ${classes.size1}`} elevation={0} />
            <Paper className={`${classes.paperPlaceHolder} ${classes.centerHorizontal} ${classes.size2}`} elevation={0} />
        </Card>
    );
}
